import * as React from 'react';
import { pure } from 'recompose';

/* UI */
import TextField from 'material-ui/TextField';

/* Style */
import {
  textInputBox,
  textActiveInputBox,
  textErrorInputBox,
} from '../../../../styles/input.style';

/* Data */
import { TextInputProps, TextInputState } from '../types';

class PasswordInput extends React.Component<TextInputProps, TextInputState> {
  constructor(props: TextInputProps) {
    super(props);
    this.state = {
      focused: false,
    };
  }

  onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = event.target;
    this.props.onChange(this.props.id, value);
  };

  onBlur = () => {
    this.setState({ focused: false });
    this.props.onBlur(this.props.id);
  };

  onFocus = () => {
    this.setState({ focused: true });
  };

  render() {
    const {
      input,
      id,
      name,
      showError,
      floatingLabelText,
      hintText,
      inputBoxStyle,
    } = this.props;
    const { focused } = this.state;

    let boxStyle;
    if (focused) {
      boxStyle = { ...textActiveInputBox };
    } else if (showError) {
      boxStyle = { ...textErrorInputBox };
    } else {
      boxStyle = { ...textInputBox };
    }

    if (inputBoxStyle) {
      boxStyle.style = { ...boxStyle.style, ...inputBoxStyle };
    }

    return (
      <TextField
        id={id}
        name={name}
        value={input}
        onBlur={this.onBlur}
        onFocus={this.onFocus}
        onChange={this.onChange}
        floatingLabelText={floatingLabelText}
        hintText={hintText}
        fullWidth
        underlineShow={false}
        type="password"
        {...boxStyle}
      />
    );
  }
}

export default pure(PasswordInput);
/* Example use with TextInputValidator:
<TextInputValidator
  id={'pw'}
  name={'password'}
  componentType={'PasswordInput'}
  floatingLabelText="Password*"
  validators={['required']}
  showError={showError}
  errorAlign={'bottom'}
  errorEnum={errorEnum}
  errorEnum={''}
  input={input}
  onChange={this.onChange}
  onBlur={this.onBlur}
  onValidate={this.onValidate}
  inputBoxStyle={{ width: '100px' }}
/>
*/
